import React,{useState} from 'react';

// tag input
import { WithContext as ReactTags } from 'react-tag-input';
import '../common/Util/TagStyle.css';

// http axios
import axios from 'axios';
import axiosUrl from '../../axios/url';
 
// custom function
import ContentsHeader from './ContentsHeader';
import ImageUploader from '../common/Util/ImageUploader';

import QuizModal from './modal/QuizModal';

export default function QuizModify(param) {

    const [quizList, setquizList] = useState([]);
    const [quizNumber, setquizNumber] = useState('');
    const [title, setTitle] = React.useState('');
    const [opened, setOpened] = React.useState();
    const [thumbFile, setThumbFile] = React.useState();
    const [oldThumbImage, setOldThumbImage] = React.useState();
    const [reference, setReference] = React.useState();
    const [keywordTags, setKeywordTags] = useState();
    const [check, setCheck] = useState(true);
    const [sendData, setSendData] = useState();
    const [quizId, setQuizId] = useState();

    //----- onchange event setting start
    function onChangeTitle(e){  setTitle(e.target.value); }

    // 공개여부 변경
    function onChangeOpened(e){ setOpened(e.target.checked);}

    // 검색어 태그 삭제
    function handleKeywordDelete(i) {  setKeywordTags(keywordTags.filter((tag, index) => index !== i)); }

    // 검색어 태그 추가
    function handleKeywordAddition(tag) {  setKeywordTags([...keywordTags, {id :tag.text, text:tag.text}]); }

    // 참고문헌 변경
    function onChangeReference(e){  setReference(e.target.value); }

    function quizNumberCheck(i) {
        setquizNumber(i);
    }

    function quizAdd() {
        var temp = quizList;
        temp.push({
            question: "", 
            questionType : "text", 
            answerSelectionType: "single", 
            answers : [], 
            answerImage: [],
            correctAnswer: [], 
            correctAnswerTemp: "",
            messageForCorrectAnswer: "",
            messageForIncorrectAnswer: "",
            explanation: ""
         });
        setquizList(temp);
        setCheck(!check)
    }

    function quizDelete(i) {
        var temp = quizList;
        temp.splice(i, 1);
        setquizList(temp);
        setCheck(!check);
    }

    function questionChange(i, value) {
        quizList[i].question = value;
        setCheck(!check);
    }

    function questionTypeChange(i, value) {
        quizList[i].questionType = value;
        quizList[i].answers = [];
        setCheck(!check);
    }

    function answerSelectionTypeChange(i, value) {
        quizList[i].answerSelectionType = value;
        setCheck(!check);
    }

    function answerAdd(i) {
        var temp = quizList[i].answers;
        temp.push("");
        setCheck(!check);
    }
    
    function answerChange(i, j, value) {
        quizList[i].answers[j] = value;
        setCheck(!check);
    }

    function answerdelete(i, j) {
        var temp = quizList[i].answers;
        temp.splice(j, 1);
        setCheck(!check);
    }
    
    function correctAnswerChange(i, value) {
        quizList[i].correctAnswerTemp = value;
        setCheck(!check);
    }
    
    function messageForCorrectAnswerChange(i, value) {
        quizList[i].messageForCorrectAnswer = value;
        setCheck(!check);
    }
     
    function messageForIncorrectAnswerChange(i, value) {
        quizList[i].messageForIncorrectAnswer = value;
        setCheck(!check);
    }
     
    function explanationChange(i, value) {
        quizList[i].explanation = value;
        setCheck(!check);
    }
    

    function onChangeThumbFile(imageFile){
        var formData = new FormData();
        formData.append('file', imageFile[0])
        return axios.post(axiosUrl.fileupload, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Max-Age': '3600',
              'Access-Control-Allow-Headers': 'Origin,Accept,X-Requested-With,Content-Type,Access-Control-Request-Method,Access-Control-Request-Headers,Authorization'
            }
          }).then(res => {
            console.log('[MEDIEX_CMS_2019_LOGGING] BlogsCreate.onChangeThumbFile SUCCESS');
            setThumbFile(res.data.filename);
          }).catch( e => {
                console.error('[MEDIEX_CMS_2019_ERROR] BlogsCreate.onChangeThumbFile - ' + e);
          })
    }

    function onChangeImageFile(imageFile){
        
        var formData = new FormData();
        imageFile.map(image => {
            formData.append('file', image);
        }); 
        return axios.post(axiosUrl.fileupload + "/multiple", formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Max-Age': '3600',
              'Access-Control-Allow-Headers': 'Origin,Accept,X-Requested-With,Content-Type,Access-Control-Request-Method,Access-Control-Request-Headers,Authorization'
            }
          }).then(res => {
            console.log('[MEDIEX_CMS_2019_LOGGING] BlogsCreate.onChangeThumbFile SUCCESS');
            var imageTemp = []
            res.data.filename.map(image => {
                imageTemp.push(image)
            })
            // quizList[quizNumber].answerImage = res.data.filename;
            quizList[quizNumber].answers = imageTemp;
          }).catch( e => {
            console.error('[MEDIEX_CMS_2019_ERROR] BlogsCreate.onChangeThumbFile - ' + e);
          })
    }

    React.useEffect(() => {
        // console.log("test");
    }, check);

    function trim(stringToTrim) {
        return stringToTrim.replace(/^\s+|\s+$/g,"");
    }

    async function updateQuiz(e){
        if(trim(title) === ''){ alert('제목을 확인하세요.'); return;}
        var list = [];
        quizList.map((quiz, quizOrder) => {
            var items = [];
            quiz.answers.map((answer, i) => {
                items.push({body: answer, order: i+1});
            })
            var temp = {
                question: quiz.question,
                questionType: quiz.questionType.toUpperCase(),
                selectionType: quiz.answerSelectionType.toUpperCase(),
                answers: quiz.correctAnswerTemp,
                correctMessage: quiz.messageForCorrectAnswer,
                incorrectMessage: quiz.messageForIncorrectAnswer,
                description: quiz.explanation,
                order: quizOrder+1,
                items: items
            }
            list.push(temp);
        })

        var tagString = "" ;
        keywordTags.map((tag, i) => {
            if( i === 0) {
                tagString = tagString + tag.text;
            } else {
                tagString = tagString +","+ tag.text;
            }
        })

        var sendData = {
            type: "Quiz",
            title: title,
            keyword: tagString,
            reference: reference,
            thumbnailUrl: thumbFile,
            opened: opened,
            quizzes: list
        }
       
        // console.log(sendData);
        var url = axiosUrl.quizzes + "/" + quizId;  
        await axios.put(url,sendData)
        .then(function (response){
            alert('퀴즈 추가되었습니다.');
            goList(e); 
         })
        .catch(function (e) {
            alert('콘텐츠가 등록에 실패하였습니다. 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] - ' + e.response.data.error.message);
        });
    }

    async function deleteQuiz(e){
        if(!window.confirm('해당 콘텐츠를 삭제하시겠습니까?')) return;

        var url = axiosUrl.quizzes + '/' + quizId;
        await axios.delete(url)
        .then(function (response){ 
            alert('콘텐츠가 삭제되었습니다.');
            goList(); 
        })
        .catch(function (e) {
            alert('콘텐츠가 삭제에 실패하였습니다. 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] blogsmodify.deleteContent - ' + e);
        });
    }

    function  preViewQuiz() {
        quizList.map((quiz) => {
            if(quiz.answerSelectionType === "single") {
                // 답변이 하나일 경우 "1"로 표현
                quiz.correctAnswer = quiz.correctAnswerTemp;
            } else if (quiz.answerSelectionType === "multiple") {
                // 답변이 여러게일 경우 [1,2]로 표현
                quiz.correctAnswer = [quiz.correctAnswerTemp];
            } else {
                console.log("type 선택해주세요");
            }
            // var tempList = quiz.correctAnswerTemp.split(',');
            // quiz.correctAnswer = tempList;
        })

        var list = {
            "quizTitle": "React Quiz Component Demo",
            "quizSynopsis": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim",
            "questions" : quizList
        }
        setSendData(list);
    }

    //미리 보기 초기화
    function callbackQuizSendData() {
        setSendData([]);
    }

    function goList(e){
        window.location = '/contents/quiz';
    }

    // 정보 가져오기
    async function getQuiz(id){
        var url = axiosUrl.quizzes + '/' + id;
        await axios.get(url)
        .then( res => {
           setTitle(res.data.title);
           setOpened(res.data.opened);
           //미리보기 이미지 때문에 추가
           var tempList = [];
           res.data.quizzes.map((quiz) => {
               //퀴즈 당 보기 리스트
               var items = [];
               quiz.items.map((item) => {
                    items.push(item.body);
               })
               //퀴즈 문제
               var temp = {
                    question: quiz.question, 
                    questionType : quiz.questionType.toLowerCase(), 
                    answerSelectionType: quiz.selectionType.toLowerCase(), 
                    answers : items, 
                    answerImage: items,
                    correctAnswer: quiz.answers, 
                    correctAnswerTemp: quiz.answers,
                    messageForCorrectAnswer: quiz.correctMessage,
                    messageForIncorrectAnswer: quiz.incorrectMessage,
                    explanation: quiz.description
               }
               //퀴즈 문제 리스트
               tempList.push(temp);
           })
           setquizList(tempList);

           // keyword 데이터 타입 맞추기
           if(res.data.keyword !== ''){

                const resultArr = res.data.keyword .split(",");
                const tagArr = [];
                resultArr.map((tagName, i) => {
                    tagArr.push({id: tagName, text: tagName});
                })
                setKeywordTags(tagArr);
            }else{
                setKeywordTags([]);
            }
           
           setReference(res.data.reference);
           setThumbFile(res.data.thumbnailUrl);
           setOldThumbImage(res.data.thumbnailUrl);
           setCheck(!check);
        })
        .catch(function (e) {
            console.error('[MEDIEX_CMS_2019_ERROR] ProgramEditDialog.getProgram - ' + e);
        });
    }

    React.useEffect(() => {
        setQuizId(param.match.params.id);
        getQuiz(param.match.params.id);
    },[param.match.params.id]);

    return(
        <div >
            <div className="content-wrapper">
                <ContentsHeader  />
                <section className="content" >
                    <div className="row">
                         <div className="col-12">
                            <button  className="btn float-right" type="button" onClick={quizAdd}>
                                <h3 className="card-title"><i className="fas fa-plus mr-1"></i> 퀴즈 추가 </h3>
                            </button>
                        </div>
                        <div className="col-6">
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">기본정보</h3>
                                </div>
                                <div className="card-body">
                                    <h3 className="card-title">제목</h3>
                                    <input type="text" className="form-control" id="title11" placeholder="제목을 입력하세요.." value={title} onChange={onChangeTitle} />
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">썸네일</h3>
                                </div>
                                <div className="card-body">
                                    {
                                        oldThumbImage !== '' && <div className="card-body text-center mb-0"><img src={oldThumbImage} width="150" height="150"/></div>
                                    }
                                    <ImageUploader callbackImage={onChangeThumbFile} />
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">검색어</h3>
                                </div>
                                <div className="card-body">
                                    <ReactTags id="keywordTag"
                                        tags={keywordTags}
                                        placeholder='검색어'
                                        handleDelete={handleKeywordDelete}
                                        handleAddition={handleKeywordAddition}
                                        autofocus={false}
                                        readOnly={false}
                                    />
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">참고문헌</h3>
                                </div>
                                <div className="card-body">
                                    <input type="text" className="form-control" id="title" placeholder="내용을 입력하세요.." onChange={onChangeReference} value={reference}/>
                                </div>
                            </div>
                            <div className="card card-danger">
                                <div className="card-header contentColor">
                                    <h3 className="card-title">공개여부</h3>
                                </div>
                                <div className="card-body">
                                    <div className="custom-control custom-switch">
                                        <input type="checkbox" className="custom-control-input" id="opened" onChange={onChangeOpened} checked={opened}/>
                                        <label className="custom-control-label" htmlFor="opened">공개</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6" id="accordionTag">
                            {quizList.map((quiz, i) => (
                                <div className="card" key={i}>
                                    <div className="card-header contentColor">
                                        <button  className="btn p-0" type="button" data-toggle="collapse" data-target={"#collapse"+i} aria-expanded="true" aria-controls={"collapse"+i} onClick={() => quizNumberCheck(i)}>
                                            <h3 className="card-title">{quiz.question || "알수 없음"}</h3>
                                        </button>
                                        <button  className="btn p-0 float-right" type="button" onClick={() => quizDelete(i)}>
                                            <i className="fas fa-trash-alt text-black-50" />
                                        </button>
                                    </div>
                                    <div className="card-body collapse"  id={"collapse"+i} aria-labelledby={"heading"+i} data-parent="#accordionTag">
                                        <div className="d-flex">
                                            <div className="col-12">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">질문</h3>
                                                        <input type="text" className="form-control" id="title11" placeholder="질문을 입력하세요.." value={quiz.question} onChange={(e) => questionChange(i, e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">질문유형</h3>
                                                        <select  className="form-control" value={quiz.questionType} onChange={(e) => questionTypeChange(i, e.target.value)}> 
                                                            <option value="text">text</option>
                                                            <option value="photo">image</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">정답유형</h3>
                                                        <select  className="form-control" value={quiz.answerSelectionType} onChange={(e) => answerSelectionTypeChange(i, e.target.value)}>
                                                            <option value="single">single</option>
                                                            <option value="multiple">multiple</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                {
                                                    quiz.questionType === "text" 
                                                    ? (
                                                        <div className="card">
                                                            <div>
                                                                <button  className="btn float-right mt-2" type="button" onClick={(e) => answerAdd(i)}>
                                                                    <h3 className="card-title"><i className="fas fa-plus mr-1"></i>보기 추가</h3>
                                                                </button>
                                                            </div>
                                                            <div className="card-body pt-1">
                                                            {quiz.answers.map((answer, j) => (
                                                                <div className="mb-2" key={j}>
                                                                    <h3 className="card-title">보기</h3>
                                                                    <input type="text" className="form-control" id="title11" placeholder="보기를 입력하세요.." value={answer} onChange={(e) => answerChange(i, j, e.target.value)} />
                                                                </div>
                                                            ))}
                                                            </div>
                                                        </div>
                                                    )
                                                    : (
                                                        <div className="card">
                                                            <div className="card-body">
                                                                <h3 className="card-title">이미지</h3>
                                                                {quiz.answerImage.map((answer, j) => (
                                                                    
                                                                    answer !== '' && <div className="card-body text-center mb-0"><img src={answer} width="150" height="150"/></div>
                                                                    
                                                                ))}
                                                                <ImageUploader callbackImage={onChangeImageFile}/>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="mb-1">
                                                            <h3 className="card-title">정답</h3>
                                                            <input type="text" className="form-control" id="title11" placeholder="정답을 입력하세요.." value={quiz.correctAnswerTemp} onChange={(e) => correctAnswerChange(i, e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">정답시 메시지</h3>
                                                        <input type="text" className="form-control" id="title11" placeholder="메시지을 입력하세요.." value={quiz.messageForCorrectAnswer} onChange={(e) => messageForCorrectAnswerChange(i, e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">오답시 메시지</h3>
                                                        <input type="text" className="form-control" id="title11" placeholder="메시지을 입력하세요.." value={quiz.messageForIncorrectAnswer}  onChange={(e) => messageForIncorrectAnswerChange(i, e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h3 className="card-title">설명</h3>
                                                        <input type="text" className="form-control" id="title11" placeholder="설명을 입력하세요.." value={quiz.explanation} onChange={(e) => explanationChange(i, e.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="button-wrapper mb-5 col-12"  >
                            <button onClick={preViewQuiz} type="button" className="btn btn-primary mr-1" data-toggle="modal" data-target="#quizModal"><i className="fas fas fa-search"></i> 미리보기</button>
                            <button onClick={updateQuiz} type="button" className="btn btn-primary mr-1"><i className="fas fa-plus"></i> 퀴즈 수정하기</button>
                            <button onClick={deleteQuiz} type="button" className="btn btn-danger  mr-1"><i className="fas fa-trash-alt"></i> 삭제</button>
                            <button onClick={goList} type="button" className="btn btn-primary"><i className="fas fa-list"></i> 목록</button>
                        </div>
                    </div>
                </section>
             </div>
            {/* 모달 */}
            <QuizModal quizList={sendData} callbackQuizSendData={callbackQuizSendData}></QuizModal>
        </div>
    );
}